import PropTypes from "prop-types";

import {
  CustomContainer,
  Button,
  Modal,
} from "components/atoms/DependencyHelper";
import Image from "components/atoms/image/image";
import LabelText from "components/atoms/label/LabelText";

import styles from "./AddedToCartPopup.module.scss";

import labels from "../../../config/labels";
import config from "../../../config";

const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;

const AddedToCartPopup = (props) => (
  <Modal
    show={props.showModal}
    onHide={props.onCloseModal}
    dialogClassName="custom-dialog"
  >
    <CustomContainer className={styles.modal}>
      <Image
        className={styles.img}
        img_path={`${imagePrefix}${props.imageUrl}`}
        img_width="2.5rem"
        img_height="2.5rem"
      />
      <LabelText className={styles.label}>
        {labels.lbl_item_add_success}
      </LabelText>

      <Button
        variant="dark"
        className={styles.btn}
        block
        onClick={props.viewCart}
        id={`${props.dealSKU}-ViewCartMobile`}
      >
        {labels.lbl_view_cart}
      </Button>

      <Button
        variant="link"
        className={styles["btn-link"]}
        onClick={props.onContinueShopping}
        id={`${labels.lbl_continue_shopping}-btn`}
      >
        {labels.lbl_continue_shopping}
      </Button>
    </CustomContainer>
  </Modal>
);

AddedToCartPopup.propTypes = {
  dealSKU: PropTypes.string,
  imageUrl: PropTypes.string,
  onCloseModal: PropTypes.func,
  onContinueShopping: PropTypes.func,
  showModal: PropTypes.bool,
  viewCart: PropTypes.func,
};

export default AddedToCartPopup;
